/**
 * GMA-1626 (CompassCare Web 11/14) — Reports route container.
 *
 * Mounts the app-shell (WebShell) around the Reports hub + SITRep preview
 * (ReportsPage) at /web/reports, wiring sidebar navigation to the router. This
 * is the route scaffolding: live NORA generation / scheduled-report + export
 * feeds (real data from the API) are a deliberate follow-up, so until then the
 * page renders the demo hub in demo builds and its fail-safe empty states
 * otherwise, inside a real, navigable frame.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import WebShell from "../../components/web/WebShell";
import ReportsPage from "./ReportsPage";
import { DEMO_DATA_ENABLED, getDemoReports } from "./demoData";

export default function WebReportsRoute() {
  const navigate = useNavigate();
  // Capture one timestamp so demo-report generation and the `now` prop agree —
  // relative-time UI drifts if each call reads the clock separately.
  const now = Date.now();
  const demo = DEMO_DATA_ENABLED ? getDemoReports(now) : null;
  return (
    <WebShell
      activeKey="reports"
      onNavigate={(section) => {
        if (section && section.path) navigate(section.path);
      }}
      title="Reports"
    >
      <ReportsPage
        sitrep={demo ? demo.sitrep : null}
        scheduled={demo ? demo.scheduled : []}
        exportHistory={demo ? demo.exportHistory : []}
        now={now}
      />
    </WebShell>
  );
}
